module.exports = __webpack_public_path__ + "img/2.953e0d83.svg";